import {ChangeDetectionStrategy, Component, inject, input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {WorkTimeModelDisplayNamePipe} from '@dv/kitadmin/work-time-controlling/mandant';
import {RequirePermissionStructuralDirective, RequireRoleAttributeDirective} from '@dv/shared/angular';
import {MandantConfigApi} from '@dv/shared/backend/api/mandant-config.api';
import {JaxMandantConfig} from '@dv/shared/backend/model/jax-mandant-config';
import {TranslocoModule} from '@jsverse/transloco';
import {TooltipModule} from 'ngx-bootstrap/tooltip';

@Component({
    selector: 'dv-mandant-config',
    imports: [
        TranslocoModule,
        FormsModule,
        TooltipModule,
        RequirePermissionStructuralDirective,
        RequireRoleAttributeDirective,
        WorkTimeModelDisplayNamePipe,
    ],
    templateUrl: './mandant-config.component.html',
    styles: `
        :host {
            display: block;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MandantConfigComponent {
    private readonly mandantConfigApi = inject(MandantConfigApi);

    public mandantId = input.required<string>();
    public mandantConfig = input.required<JaxMandantConfig>();

    public updateConfig(config: JaxMandantConfig): void {
        const mandantId = this.mandantId();
        this.mandantConfigApi.update$({
            mandantId,
            jaxMandantConfig: {
                defaultWorkTimeModelId: config.defaultWorkTimeModelId,
                defaultTerminTypeId: config.defaultTerminTypeId,
                workTimeModels: [],
                terminTypes: [],
            },
        }).subscribe();
    }
}
